import { capitalizeWord } from "@hypexone/uicore";
import { getEnvVariable, WhitelabelEnvDTO } from "../../../constants/brandConfig";
import Button from "../shared/Button/Button";
import { domain } from "../../../constants/Branding";

const websiteUrls: WhitelabelEnvDTO["skins"] = getEnvVariable(domain, 'skins') || [];

const SkinOptions = () => {
  const handleSkinChange = (domain) => {
    localStorage.setItem("userSkin", domain);
    const jwtToken = sessionStorage.getItem("jwt_token");
    sessionStorage.clear();
    window.open(`http://${domain}/login?authToken=${jwtToken}`, "_self");
  };

  return (
    <div className="flex flex-col py-1 pr-0">
      {websiteUrls?.map((skin) => (
        <Button
          key={skin.label}
          className={`${
            skin.disabled ? "" : ""
          } text-black text-sm px-2 py-[6px] text-center last:border-b-0 border-b cursor-pointer hover:underline`}
          onClick={() => handleSkinChange(skin.domain)}
          disabled={skin.disabled}
        >
          {"  "}
          {capitalizeWord(skin.label)}
        </Button>
      ))}
    </div>
  );
};

export default SkinOptions;
